import { render, staticRenderFns } from "./FaxNumberForm.vue?vue&type=template&id=5abd6dbd"
import script from "./FaxNumberForm.vue?vue&type=script&lang=js"
export * from "./FaxNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports